import React from "react";
import { FileText, Clock, CheckCircle, XCircle, Inbox } from "lucide-react";

const STATS = [
  { key: "submitted", label: "Submitted", icon: Inbox, color: "text-blue-400", bg: "bg-blue-500/10 border-blue-500/20", activeBg: "bg-blue-500/25 border-blue-400 ring-1 ring-blue-400/40" },
  { key: "in_review", label: "In Review", icon: Clock, color: "text-yellow-400", bg: "bg-yellow-500/10 border-yellow-500/20", activeBg: "bg-yellow-500/25 border-yellow-400 ring-1 ring-yellow-400/40" },
  { key: "accepted", label: "Accepted", icon: CheckCircle, color: "text-green-400", bg: "bg-green-500/10 border-green-500/20", activeBg: "bg-green-500/25 border-green-400 ring-1 ring-green-400/40" },
  { key: "closed", label: "Closed", icon: XCircle, color: "text-slate-400", bg: "bg-slate-500/10 border-slate-500/20", activeBg: "bg-slate-500/25 border-slate-400 ring-1 ring-slate-400/40" },
];

/**
 * AnalyticsBar — Clickable summary cards that filter referrals by status.
 */
const AnalyticsBar = ({ referrals, activeFilter, onFilterChange }) => {
  const counts = { submitted: 0, in_review: 0, accepted: 0, closed: 0 };
  referrals.forEach((r) => {
    const s = r.status || "submitted";
    if (counts[s] !== undefined) counts[s]++;
    else counts.submitted++;
  });

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-testid="analytics-bar">
      {STATS.map((s) => {
        const Icon = s.icon;
        const isActive = activeFilter === s.key;
        return (
          <button
            key={s.key}
            onClick={() => onFilterChange(isActive ? null : s.key)}
            className={`rounded-xl border p-4 text-left transition-all cursor-pointer ${isActive ? s.activeBg : s.bg} hover:opacity-90`}
            data-testid={`stat-${s.key}`}
          >
            <div className="flex items-center justify-between mb-1">
              <Icon className={`w-4 h-4 ${s.color}`} />
              <span className={`text-2xl font-bold ${s.color}`}>{counts[s.key]}</span>
            </div>
            <p className={`text-xs ${isActive ? "text-slate-200 font-medium" : "text-slate-400"}`}>
              {s.label}{isActive ? " (filtered)" : ""}
            </p>
          </button>
        );
      })}
      <div className="col-span-2 md:col-span-4 flex items-center gap-2 px-1">
        <FileText className="w-3.5 h-3.5 text-slate-500" />
        <span className="text-xs text-slate-500">Total: {referrals.length} referrals</span>
        {activeFilter && (
          <button
            onClick={() => onFilterChange(null)}
            className="text-xs text-blue-400 hover:text-blue-300 ml-2"
            data-testid="clear-status-filter"
          >
            Clear filter
          </button>
        )}
      </div>
    </div>
  );
};

export default AnalyticsBar;
